const ProductsData = [
    {
        id: 1,
        title: "Walk Behind Automatic Scrubber Driers",
        tag: "walk-behind-automatic-scrubber-driers",
        description: "Our Walk Behind Scrubber dryers have high contact pressure and scrubbers which can clean, strip and polish both uneven and smooth floors or shampoo carpets.",
        cover: require("../../Assets/Products/Walk Behind Scrubber Driers.png"),
        products: [
            {
                id: 1,
                cover: require("../../Assets/Products/Walk Behind.png"),
                featurescov: require("../../Assets/Products/Walk Behindfet.png"),
                heading: [
                    {
                        id: 1,
                        title: "Technical Data"
                    },
                    {
                        id: 2,
                        title: " "
                    },
                    {
                        id: 3,
                        title: "KV-35 Cable"
                    },
                    {
                        id: 4,
                        title: "KV-50 Cable"
                    },
                    {
                        id: 5,
                        title: "GT-50 Cable"
                    },
                    {
                        id: 6,
                        title: "CT-50 Battery"
                    },
                    {
                        id: 7,
                        title: "KV-55 Cable/Battery"
                    },
                    {
                        id: 8,
                        title: "KV-65 Cable/Battery"
                    },
                ],
                features: [
                    {
                        id: 9,
                        side: "Scrubbing Width",
                        detail1: "mm",
                        detail2: "455",
                        detail3: "510",
                        detail4: "500",
                        detail5: "510",
                        detail6: "530",
                        detail7: "530",
                    },
                    {
                        id: 10,
                        side: "Squeegee Width",
                        detail1: "mm",
                        detail2: "755",
                        detail3: "755",
                        detail4: "815",
                        detail5: "755",
                        detail6: "790",
                        detail7: "790",
                    },
                    {
                        id: 11,
                        side: "No. of Brushes",
                        detail1: "-",
                        detail2: "1(Disc)",
                        detail3: "1(Disc)",
                        detail4: "1(Disc)",
                        detail5: "1(Disc)",
                        detail6: "1(Disc)",
                        detail7: "1(Disc)",
                    },
                    {
                        id: 12,
                        side: "Max. Productivity",
                        detail1: "Sq.m/Hr.",
                        detail2: "1700",
                        detail3: "1800",
                        detail4: "2000",
                        detail5: "1800",
                        detail6: "2120",
                        detail7: "2250",
                    },
                    {
                        id: 13,
                        side: "Solution Tank Capacity",
                        detail1: "Ltr.",
                        detail2: "32",
                        detail3: "45",
                        detail4: "50",
                        detail5: "45",
                        detail6: "50",
                        detail7: "60",
                    },
                    {
                        id: 14,
                        side: "Recovery Tank Capacity",
                        detail1: "Ltr.",
                        detail2: "35",
                        detail3: "50",
                        detail4: "50",
                        detail5: "50",
                        detail6: "55",
                        detail7: "65",
                    },
                    {
                        id: 15,
                        side: "Main Supply",
                        detail1: "Volt/Hz",
                        detail2: "220/50",
                        detail3: "220/50",
                        detail4: "220/50",
                        detail5: "24V/110Ah",
                        detail6: "220/50,24V/110Ah",
                        detail7: "220/50,24V/110Ah",
                    },
                    {
                        id: 16,
                        side: " Brush Diameter",
                        detail1: "mm",
                        detail2: "455",
                        detail3: "510",
                        detail4: "500",
                        detail5: "510",
                        detail6: "530",
                        detail7: "530",
                    },
                    {
                        id: 17,
                        side: "Maximum  Speed",
                        detail1: "Km/Hr.",
                        detail2: "3.5",
                        detail3: "3.5",
                        detail4: "4",
                        detail5: "3.5",
                        detail6: "4",
                        detail7: "4.5",
                    },
                    {
                        id: 18,
                        side: "Weight",
                        detail1: "Kg.",
                        detail2: "76",
                        detail3: "68",
                        detail4: "89",
                        detail5: "78",
                        detail6: "90/145",
                        detail7: "95/150",
                    },
                ]
            },
        ]
    },
    {
        id: 2,
        title: "Ride On Automatic Scrubber Driers",
        tag: "ride-on-automatic-scrubber-driers",
        description: "Our Automatic Scrubber dryers have high contact pressure and scrubbers which can clean, strip and polish both uneven and smooth floors or shampoo carpets.",
        cover: require("../../Assets/Products/Walk Behind Automatic Scrubber Driers.png"),
        products: [
            {
                id: 1,
                cover: require("../../Assets/Products/rideon1.png"),
                featurescov: require("../../Assets/Products/ridon1fet.png"),
                heading: [
                    {
                        id: 1,
                        title: "Technical Data"
                    },
                    {
                        id: 2,
                        title: "Scrubbing Width"
                    },
                    {
                        id: 3,
                        title: "Squeegee Width"
                    },
                    {
                        id: 4,
                        title: "No. of Brushes"
                    },
                    {
                        id: 5,
                        title: "Max. Productivity"
                    },
                    {
                        id: 6,
                        title: "Solution Tank Capacity"
                    },
                    {
                        id: 7,
                        title: "Recovery Tank Capacity"
                    },
                    {
                        id: 8,
                        title: "Main Supply"
                    },
                    {
                        id: 9,
                        title: "Brush Diameter"
                    },
                    {
                        id: 10,
                        title: "Maximum Speed"
                    },
                    {
                        id: 11,
                        title: "Weight / Dimensions"
                    },
                ],
                features: [
                    {
                        id: 12,
                        side: "MODEL",
                        detail1: "mm",
                        detail2: "mm",
                        detail3: "-",
                        detail4: "Sq.mtr/Hr",
                        detail5: "Ltrs",
                        detail6: "Ltrs",
                        detail7: "Volts",
                        detail8: "mm",
                        detail9: "Km/Hr",
                        detail10: "Kg(xwxh)cm",
                    },
                    {
                        id: 13,
                        side: "KV-90",
                        detail1: "570",
                        detail2: "900",
                        detail3: "1",
                        detail4: "3900",
                        detail5: "90",
                        detail6: "100",
                        detail7: "24/150",
                        detail8: "535",
                        detail9: "0 to 7",
                        detail10: "248/130x66x117",
                    },
                    {
                        id: 14,
                        side: "KV-100",
                        detail1: "660",
                        detail2: "900",
                        detail3: "2",
                        detail4: "4620",
                        detail5: "90",
                        detail6: "100",
                        detail7: "24/150",
                        detail8: "300 x 2",
                        detail9: "0 to 7",
                        detail10: "258/130x66x117",
                    },
                    {
                        id: 15,
                        side: "KV-110",
                        detail1: "700",
                        detail2: "1020",
                        detail3: "2",
                        detail4: "4900",
                        detail5: "100",
                        detail6: "100",
                        detail7: "24/210",
                        detail8: "350 x 2",
                        detail9: "0 to 8",
                        detail10: "282/130x70x117",
                    },
                    {
                        id: 16,
                        side: "KV-130",
                        detail1: "800",
                        detail2: "1100",
                        detail3: "2",
                        detail4: "6400",
                        detail5: "120",
                        detail6: "130",
                        detail7: "24/240",
                        detail8: "400 x 2",
                        detail9: "0 to 9",
                        detail10: "332/160x110x138",
                    },
                    {
                        id: 17,
                        side: "KV-150",
                        detail1: "850",
                        detail2: "1200",
                        detail3: "2",
                        detail4: "7650",
                        detail5: "140",
                        detail6: "150",
                        detail7: "24/240",
                        detail8: "425 x 2",
                        detail9: "0 to 9",
                        detail10: "435/160x110x142",
                    },
                ]
            },
            {
                id: 2,
                cover: require("../../Assets/Products/rideon2.png"),
                featurescov: require("../../Assets/Products/ridon2fet.png"),
                heading: [
                    {
                        id: 1,
                        title: "Technical Data"
                    },
                    {
                        id: 2,
                        title: "Scrubbing Width"
                    },
                    {
                        id: 3,
                        title: "Squeegee Width"
                    },
                    {
                        id: 4,
                        title: "No. of Brushes"
                    },
                    {
                        id: 5,
                        title: "Max. Productivity"
                    },
                    {
                        id: 6,
                        title: "Solution Tank Capacity"
                    },
                    {
                        id: 7,
                        title: "Recovery Tank Capacity"
                    },
                    {
                        id: 8,
                        title: "Main Supply"
                    },
                    {
                        id: 9,
                        title: "Brush Diameter"
                    },
                    {
                        id: 10,
                        title: "Maximum Speed"
                    },
                    {
                        id: 11,
                        title: "Weight"
                    },
                ],
                features: [
                    {
                        id: 12,
                        side: "MODEL",
                        detail1: "mm",
                        detail2: "mm",
                        detail3: "-",
                        detail4: "Sq.mtr/Hr",
                        detail5: "Ltrs",
                        detail6: "Ltrs",
                        detail7: "Volts/Ah",
                        detail8: "mm",
                        detail9: "Km/Hr",
                        detail10: "Kg",
                    },
                    {
                        id: 13,
                        side: "KV-180",
                        detail1: "960",
                        detail2: "1200",
                        detail3: "2",
                        detail4: "8640",
                        detail5: "165",
                        detail6: "180",
                        detail7: "24/240",
                        detail8: "480 x 2",
                        detail9: "0 to 9",
                        detail10: "435",
                    },
                    {
                        id: 14,
                        side: "KV-270",
                        detail1: "1060",
                        detail2: "1380",
                        detail3: "2",
                        detail4: "9540",
                        detail5: "250",
                        detail6: "270",
                        detail7: "36/240",
                        detail8: "530 x 2",
                        detail9: "0 to 9",
                        detail10: "583",
                    },
                ],
                heading2: [
                    {
                        id: 15,
                        title: "Technical Data"
                    },
                    {
                        id: 16,
                        title: "Traction motor Watts"
                    },
                    {
                        id: 17,
                        title: "Brush motor Watts"
                    },
                    {
                        id: 18,
                        title: "Vacuum motor Watts"
                    },
                    {
                        id: 19,
                        title: "Brush pressure MPa"
                    },
                    {
                        id: 20,
                        title: "Brush speed rpm"
                    },
                    {
                        id: 21,
                        title: "Grade ability %"
                    },
                    {
                        id: 22,
                        title: "No. of Batteries"
                    },
                    {
                        id: 23,
                        title: "Working Hours"
                    },
                    {
                        id: 24,
                        title: "Noise level dBA"
                    },
                    {
                        id: 25,
                        title: "Dimensions (LxWxH) cm"
                    },
                ],
                features2: [
                    {
                        id: 26,
                        side: "KV-180",
                        detail1: "800",
                        detail2: "550 x 2",
                        detail3: "554",
                        detail4: "4.5",
                        detail5: "180",
                        detail6: "<25",
                        detail7: "4 x 6V",
                        detail8: "3 to 5",
                        detail9: "67",
                        detail10: "163 x 87 x 140",
                    },
                    {
                        id: 27,
                        side: "KV-270",
                        detail1: "850",
                        detail2: "650 x 2",
                        detail3: "800",
                        detail4: "4.5",
                        detail5: "180",
                        detail6: "<25",
                        detail7: "6 x 6V",
                        detail8: "4 to 6",
                        detail9: "65",
                        detail10: "187 x 108 x 146",
                    },
                ],
            },
            {
                id: 3,
                title: "KV-110",
                cover: require("../../Assets/Products/rideon3.png"),
                featurescov: require("../../Assets/Products/ridon3fet.png"),
                heading: [
                    {
                        id: 1,
                        title: "Technical Data"
                    },
                    {
                        id: 2,
                        title: "Scrubbing Width"
                    },
                    {
                        id: 3,
                        title: "Squeegee Width"
                    },
                    {
                        id: 4,
                        title: "No. of Brushes"
                    },
                    {
                        id: 5,
                        title: "Max. Productivity"
                    },
                    {
                        id: 6,
                        title: "Solution Tank Capacity"
                    },
                    {
                        id: 7,
                        title: "Recovery Tank Capacity"
                    },
                    {
                        id: 8,
                        title: "Main Supply"
                    },
                    {
                        id: 9,
                        title: "Brush Diameter"
                    },
                    {
                        id: 10,
                        title: "Maximum Speed"
                    },
                    {
                        id: 11,
                        title: "Weight / Dimensions"
                    },
                ],
                features: [
                    {
                        id: 12,
                        side: "MODEL",
                        detail1: "mm",
                        detail2: "mm",
                        detail3: "-",
                        detail4: "Sq.mtr/Hr",
                        detail5: "Ltrs",
                        detail6: "Ltrs",
                        detail7: "Voltas",
                        detail8: "mm",
                        detail9: "Km/Hr",
                        detail10: "Kg",
                    },
                    {
                        id: 13,
                        side: "KV-400",
                        detail1: "1120",
                        detail2: "1380",
                        detail3: "2-3",
                        detail4: "10080",
                        detail5: "390",
                        detail6: "400",
                        detail7: "36/440",
                        detail8: "560",
                        detail9: "0 to 9",
                        detail10: "1164",
                    },
                ],
                heading2: [
                    {
                        id: 14,
                        title: "Technical Data"
                    },
                    {
                        id: 15,
                        title: "Traction motor Watts"
                    },
                    {
                        id: 16,
                        title: "Brush motor Watts"
                    },
                    {
                        id: 17,
                        title: "Vacuum motor Watts"
                    },
                    {
                        id: 18,
                        title: "Lifting motor Watts"
                    },
                    {
                        id: 19,
                        title: "Brush speed rpm"
                    },
                    {
                        id: 20,
                        title: "Brush pressure MPa"
                    },
                    {
                        id: 21,
                        title: "No. of Batteries"
                    },
                    {
                        id: 22,
                        title: "Working Hours"
                    },
                    {
                        id: 23,
                        title: "Noise level dBA"
                    },
                    {
                        id: 24,
                        title: "Dimensions (LxWxH) cm"
                    },
                ],
                features2: [
                    {
                        id: 25,
                        side: "KV-400",
                        detail1: "1500",
                        detail2: "680 x 2",
                        detail3: "554 x 2",
                        detail4: "100 x 2",
                        detail5: "215",
                        detail6: "4.8",
                        detail7: "36 V",
                        detail8: "6 to 8",
                        detail9: "67",
                        detail10: "223 x 135 x 154",
                    },
                ],
            },
        ]
    },
]
export default ProductsData;